import styled from 'styled-components';
import { px2rem, getSpace, mq, getColor } from '../../../../stylesheets/tools';

const StyledEducationTabletCard = styled.div`
  position: relative;
  &:hover,
  &:focus {
    cursor: pointer;
    background-position: top right, top right, bottom left, bottom left, top left;
    background-repeat: no-repeat;
    background-image: linear-gradient(180deg, currentColor, currentColor),
      linear-gradient(225deg, currentColor, currentColor),
      linear-gradient(0deg, currentColor, currentColor),
      linear-gradient(90deg, currentColor, currentColor),
      linear-gradient(
        135deg,
        transparent 18px,
        currentColor 18px,
        currentColor 20px,
        transparent 20px
      );
    background-size: calc(100% - 26px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 26px), 36px 36px;

    ${mq('m')} {
      background-image: linear-gradient(180deg, currentColor, currentColor),
        linear-gradient(225deg, currentColor, currentColor),
        linear-gradient(0deg, currentColor, currentColor),
        linear-gradient(90deg, currentColor, currentColor),
        linear-gradient(
          135deg,
          transparent 24px,
          currentColor 24px,
          currentColor 26px,
          transparent 26px
        );
      background-size: calc(100% - 34px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 34px), 36px 36px;
    }

    &:after {
      background-color: ${getColor('lightGray')};
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      z-index: -2;
      width: 100%;
      content: '';
      clip-path: polygon(28px 0, 100% 0, 100% 100%, 0 100%, 0 28px);

      ${mq('m')} {
        clip-path: polygon(34px 0, 100% 0, 100% 100%, 0 100%, 0 34px);
      }
    }
  }

  &:hover .tablet-card__link {
    border-color: black !important;
  }

  .tablet-card {
    display: flex;
    width: 100%;
    position: relative;
    padding: ${px2rem('16px')};
    flex-direction: column;

    ${mq('m')} {
      padding: ${px2rem('26px')};
      flex-direction: row;
    }

    .tablet-card__content {
      padding-right: ${px2rem('26px')};
      margin: ${getSpace('xs')} 0;

      ${mq('m')} {
        margin: unset;
      }
      .tablet-card__headline {
        display: flex;
        width: 100%;
        gap: ${px2rem('15px')};

        ${mq('m')} {
          gap: ${px2rem('0px')};

          .tablet-card__number {
            width: ${px2rem('100px')};
            flex-shrink: 0;
          }
        }
        .tablet-card__headline-content {
          .tablet-card__headline-text {
            font-size: ${px2rem('20px')};
          }
        }
      }

      .tablet-card__copy {
        margin: ${px2rem('10px')} 0 0 0;
        color: ${getColor('teaserGray')};
        line-height: 1.75;

        ${mq('m')} {
          padding-left: ${px2rem('100px')};
        }
      }
    }

    .tablet-card__link {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${getSpace('xs')} 0 ${px2rem('8px')} 0;
      border-top: 2px solid ${getColor('gray')};

      .tablet-card__link-inner {
        align-items: center;
        gap: ${px2rem('10px')};
        display: flex;
      }
      .tablet-card__link-title {
        font-size: ${px2rem('18px')};
      }
      ${mq('m')} {
        margin-left: auto;
        border-top: none;
        border-left: 2px solid ${getColor('gray')};
        padding: 0 ${getSpace('xxs')} 0 ${getSpace('s')};

        .tablet-card__link-title {
          display: none;
        }
      }
    }

    .tablet-card__stretched-link {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
    }

    .tablet-card__tag-line {
      align-items: center;
      justify-content: space-between;

      ${mq('m')} {
        gap: ${px2rem('16px')};
        margin-bottom: ${getSpace('xxs')};
        justify-content: start;
      }

      &.hidden {
        &--desktop {
          display: flex;

          ${mq('m')} {
            display: none;
          }
        }
        &--mobile {
          display: none;

          ${mq('m')} {
            display: flex;
          }
        }
      }
      .tablet-card__tag {
        .filter-tag {
          .filter-tag__title {
            font-size: ${px2rem('16px')};
          }
        }
      }
    }
  }
`;

export default StyledEducationTabletCard;
